import { createContext } from "react";

type HaNFilterBarContextValue = {
  areFiltersTransparent: boolean;
};

// How the filter bar wants its filters drawn, so tab parts don't check the layout themselves
export const HaNFilterBarContext = createContext<HaNFilterBarContextValue | null>(null);
